export default __webpack_public_path__ + "static/media/image.4ac9d165.svg";